<ion-content #pageTop class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Cambio de clave"></app-title-three>
  </div>

  <form [formGroup]="updatePasswordForm">
    <ion-grid class="form-data">
      <ion-row>
        <ion-col size="12">
          <ion-label
            >Muy bien! has ingresado con la clave que enviamos por correo. Ahora
            cambia tu clave por una que recuerdes fácilmente</ion-label
          >

          <ion-item>
            <ion-label position="floating">Contraseña nueva</ion-label>
            <ion-input
              mode="md"
              formControlName="new_password"
              maxlength="15"
              [type]="typeInput[1]"
            >
            </ion-input>
            <ion-icon
              slot="end"
              [name]="eyeImage[1]"
              class="icon-password"
              (click)="changeImage(1)"
              mode="md"
            ></ion-icon>
          </ion-item>

          <div *ngIf="errorControl.new_password.errors != null">
            <div
              *ngIf="( errorControl.new_password.touched ||  errorControl.new_password.dirty) &&  errorControl.new_password.errors.nameNumberMin"
            >
              <ion-text color="primary" class="text-12"
                >Debe tener mas de 6 caracteres</ion-text
              >
            </div>
            <div
              *ngIf="( errorControl.new_password.touched ||  errorControl.new_password.dirty) &&  errorControl.new_password.errors.nameNumberMax"
            >
              <ion-text color="primary" class="text-12"
                >Debe tener máximo 15 caracteres.</ion-text
              >
            </div>
            <div
              *ngIf="( errorControl.new_password.touched ||  errorControl.new_password.dirty) &&  errorControl.new_password.errors.nameRequerid"
            >
              <ion-text color="primary" class="text-12"
                >La nueva clave es requerida.</ion-text
              >
            </div>
            <div
              *ngIf="
              (errorControl.new_password.touched || errorControl.new_password.dirty) &&
              errorControl.new_password.errors.nameText
            "
            >
              <ion-text color="primary" class="text-12"
                >La nueva contraseña debe tener por lo menos una<br />letra
                mayúscula, una minúscula, un número y un carácter
                especial.</ion-text
              >
            </div>
          </div>

          <ion-item>
            <ion-label position="floating">Repetir contraseña</ion-label>
            <ion-input
              mode="md"
              formControlName="confirm_password"
              maxlength="15"
              id="confirm_password"
              [type]="typeInput[2]"
            >
            </ion-input>
            <ion-icon
              slot="end"
              [name]="eyeImage[2]"
              class="icon-password"
              (click)="changeImage(2)"
              mode="md"
            ></ion-icon>
          </ion-item>

          <div *ngIf="errorControl.confirm_password.errors != null">
            <div
              *ngIf="( errorControl.confirm_password.touched ||  errorControl.confirm_password.dirty) &&  errorControl.confirm_password.errors.nameNumberMin"
            >
              <ion-text color="primary" class="text-12"
                >Debe tener al menos 8 caracteres</ion-text
              >
            </div>
            <div
              *ngIf="( errorControl.confirm_password.touched ||  errorControl.confirm_password.dirty) &&  errorControl.confirm_password.errors.nameNumberMax"
            >
              <ion-text color="primary" class="text-12"
                >Debe tener máximo 15 caracteres.</ion-text
              >
            </div>
            <div
              *ngIf="( errorControl.confirm_password.touched ||  errorControl.confirm_password.dirty) &&  errorControl.confirm_password.errors.nameRequerid"
            >
              <ion-text color="primary" class="text-12"
                >La confirmación de la contraseña es requerida.</ion-text
              >
            </div>
            <div
              *ngIf="(errorControl.confirm_password.touched) && errorControl.confirm_password.errors?.confirmedValidator"
            >
              <ion-text color="primary" class="text-12"
                >Debe ser igual a la nueva clave.</ion-text
              >
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Botones -->
    <ion-grid>
      <ion-row>
        <ion-col class="ion-text-center" size="12">
          <button
            [disabled]="updatePasswordForm.invalid"
            (click)="changePassword()"
            id="btn-create-modal"
            class="btn-primary-2"
          >
            Guardar
          </button>
        </ion-col>
        <ion-col class="ion-text-center" size="12">
          <button
            (click)="closeModal()"
            id="btn-edit-modal"
            class="btn-primary btn-close"
          >
            Cerrar
          </button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
